import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { AppConfig, AppListenConfig } from '../../config'
import { ConfigActionTypes } from './config.actions'
import { ConfigActions } from './config.actions'

export interface State extends EntityState<AppListenConfig> {
  loaded: boolean
  loading: boolean
  error: [] | null
  listenConfig: AppListenConfig | null
  staticConfig: AppConfig | null
}

export const adapter: EntityAdapter<AppListenConfig> = createEntityAdapter<AppListenConfig>()

export const initialState: State = adapter.getInitialState({
  loaded: false,
  loading: false,
  error: null,
  listenConfig: null,
  staticConfig: null,
})

export function reducer(state = initialState, action: ConfigActions): State {
  switch (action.type) {
    case ConfigActionTypes.onInitConfig:
    case ConfigActionTypes.onGetStaticConfig:
      return { ...state, loading: true }
    case ConfigActionTypes.onGetStaticConfigSuccess:
      return { ...state, staticConfig: action.payload, loaded: true, loading: false }
    case ConfigActionTypes.onListenConfigChanged:
      return { ...state, listenConfig: action.payload, loaded: true, loading: false }
    default:
      return state
  }
}
